import { StateService } from '@uirouter/angularjs';
import * as moment from 'moment';
import { Component } from '../../../../component-decorator';

function handleSlaText(date, timeType, timeTypeLabel) {
  const now = moment();
  const sla = moment(date);

  const diff = sla.diff(now, timeType);
  if (diff === 1) {
    return 'Resposta em até ' +  diff + ' ' + timeTypeLabel + ' útil';
  } else if (diff > 1) {
    return 'Resposta em até ' +  diff + ' ' + timeTypeLabel + 's úteis';
  }
}

@Component({
  componentName: 'appAtendimentoTabela',
  controllerAs: '$ctrl',
  template: require('./tabela.component.html'),
  bindings: {
    tickets: '<',
    refreshing: '<',
    total: '<',
    query: '<',
    onQueryChanged: '&',
  },
})
export class AtendimentoTabelaComponent implements angular.IController {
  public query;
  public onQueryChanged: (query: any) => void;

  constructor(private $state: StateService) {
    'ngInject';
  }

  public mapTicketStatus(ticket) {
    switch (ticket.status) {
      case 'new':
      case 'open':
      case 'hold':
        return 'Em análise';
      case 'pending':
        return 'Responder';
      case 'closed':
      case 'solved':
        return 'Finalizado';
    }

    return ticket.status;
  }

  public mapTicketSLA(ticket) {
    if (!ticket || !ticket.breachAt) {
      return '';
    }

    const date = new Date(ticket.breachAt);
    if (!(date instanceof Date) || !moment.isDate(date)) {
      return '';
    }

    if (date <= new Date()) {
      return 'Resposta em atraso';
    }

    return handleSlaText(date, 'days', 'dia')
      || handleSlaText(date, 'hours', 'hora')
      || handleSlaText(date, 'minutes', 'minuto');
  }

  public ticketSlaClass(ticket) {
    if (!ticket || !ticket.breachAt) {
      return;
    }

    const date = new Date(ticket.breachAt);
    if (!(date instanceof Date) || !moment.isDate(date)) {
      return;
    }

    if (date > new Date()) {
      return 'success';
    }

    return 'danger';
  }

  public ticketHasSLA(ticket) {
    if (!ticket || !ticket.breachAt) {
      return false;
    }

    const date = new Date(ticket.breachAt);
    if (!(date instanceof Date) || !moment.isDate(date)) {
      return false;
    }

    return true;
  }

  onPaginate() {
    this.onQueryChanged({
      $event: this.query
    });
  }

  ticketSelected(ticket) {
    this.$state.go('relacionamentodetalhes', { ticketId: ticket.id });
  }
}
